import React from 'react';
import Button from '../atoms/Button';
import { Auth } from 'aws-amplify';

const LogoutButton: React.FC = () => {
return <Button fontSize={'16px'} borderRadius={'30px'} colorType={'danger'} margin={'0 0 0 30px;'} onClick={()=>Auth.signOut()}>Logout</Button>;
};

export default LogoutButton;
